import { useMemo } from "react";
import { usePractitionerRoleContext } from "@/contexts/PractitionerRoleContext";
import { useFormatter } from "@/utils/useFormatter";

export interface ProfessionalOption {
  /** `Practitioner/<oid>-<cpf>` (mesmo formato do passo "Serviço de saúde" do Form). */
  value: string;
  label: string;
}

/**
 * Profissionais ATIVOS da organização, para os filtros da visão clínica.
 * Vem do PractitionerRoleContext (já carregado no app): nenhuma chamada extra.
 */
export function useOrganizationProfessionalOptions(): ProfessionalOption[] {
  const { practitionerRole } = usePractitionerRoleContext();

  return useMemo(() => {
    const byReference = new Map<string, ProfessionalOption>();
    (practitionerRole || []).forEach((entry) => {
      const role = entry.resource;
      const reference = role?.practitioner?.reference;
      if (!role || role.active === false || !reference || byReference.has(reference)) return;
      byReference.set(reference, {
        value: reference,
        label: useFormatter.formatNameDisplay(role.practitioner?.display || "Profissional"),
      });
    });
    return [...byReference.values()].sort((first, second) =>
      first.label.localeCompare(second.label, "pt-BR"),
    );
  }, [practitionerRole]);
}
